import { AsyncPipe, NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'primary-secondary',
  templateUrl: './primary-secondary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, NgClass],
})
export class PrimarySecondaryComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  isEmptyAndNull(obj: any) {
    if (!obj) return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false;
  }

  getColor(color: string) {
    return `text-${color}-400`;
  }
}
